<template>
    <div ref="gBody" id="gBody" class="g-body" style="overflow-scrolling: touch;">
        <!-- old -->
        <!-- <headerTop /> -->
        <SiteHead class="SiteHead" />
        <SiteBody ref="pageBody" class="p-body">
            <BannerModuleVue />
            <IntroModule class="IntroModule" />
            <MarketModule class="MarketModule" :marketList="marketList" />
            <DownloadModule class="DownloadModule" />
            <PresenceModule class="PresenceModule" />
            <StoryModule class="StoryModule" />
            <!-- <PartnerModule class="PartnerModule" /> -->
            <SiteMap class="SiteMap" />
            <div :class="$style['join-us']" class="flex justify-between items-center">
                <div :class="$style['state-pos-left']">
                    <img :class="$style['join-us-thumb']" src="@/assets/images/newImg/join-usV3.png" alt="" />
                </div>
                <div :class="$style['state-pos-right']">
                    <button :class="$style['btn--download-app']">
                        <span @click="$router.push({path:'/download',query:{type:'purchase'}})" :class="$style['text']">{{$t('300345')}}</span>
                    </button>
                </div>
            </div>
        </SiteBody>
        <SiteFoot />
        <!-- <div ref="sideOperGroup" :class="$style['side-oper-group']" :data-state-show="sideOperGroupShow" class="grid">
            <div :class="$style['oper-item']" class="flex justify-center items-center">
                <UeIcon :class="$style['ic']" name="message-dots-circle" />
            </div>
            <div :class="$style['oper-item']" class="flex justify-center items-center">
                <UeIcon :class="$style['ic']" name="twitter" />
            </div>
            <div :class="$style['oper-item']" class="flex justify-center items-center">
                <UeIcon :class="$style['ic']" name="telegram" />
            </div>
        </div> -->
    </div>
</template>

<script>
// import headerTop from '../compontents/headerTop'
import '@/assets/newCss/reset.scss'
import '@/assets/tailwendcss.css'
import '@/assets/uemo-icon-font/fonts/ueicon.css'
import '@/assets/newCss/var.scss'
import '@/assets/newCss/base.scss'

import WOW from 'wow.js'
import mitt from 'mitt'
import throttle from 'lodash/throttle'
import SiteHead from '../compontents/newHome/SiteHead.vue'
import SiteBody from '../compontents/newHome/SiteBody.vue'
import BannerModuleVue from '../compontents/newHome/index/BannerModule.vue'
import IntroModule from '../compontents/newHome/index/IntroModule.vue'
import MarketModule from '../compontents/newHome/index/MarketModule.vue'
import PartnerModule from '../compontents/newHome/index/PartnerModule.vue'
import DownloadModule from '../compontents/newHome/index/DownloadModule.vue'
import PresenceModule from '../compontents/newHome/index/PresenceModule.vue'
import StoryModule from '../compontents/newHome/index/StoryModule.vue'
import SiteMap from '../compontents/newHome/SiteMap.vue'
import SiteFoot from '../compontents/newHome/SiteFoot.vue'
import * as configs from '../../config/config'
import { toNonExponential, parseTime } from '../utils'
import pako from 'pako'
import { setCookie, getCookie } from '@/utils/auth'
import { mapGetters } from 'vuex'

// import { getUserInfo } from '@/api/user'

const mittManage = mitt()
export default {
    name: 'index',
    components: {
        SiteHead,
        SiteBody,
        SiteMap,
        SiteFoot,
        BannerModuleVue,
        IntroModule,
        MarketModule,
        DownloadModule,
        PresenceModule,
        PartnerModule,
        StoryModule,
    },
    data() {
        return {
            // mittManage: mitt(),
            // pageBody: null,
            websocke: null,
            pongTime: null,
            rateConfig: {},
            marketConfig: {},
            marketList: [],
            sideOperGroupShow: false,
            _throttleWatch: null,
        }
    },
    computed: {
        ...mapGetters(['isDirection', 'language','user']),
    },
    created() {
        window.document.documentElement.setAttribute(
            'dir',
            this.isDirection ? 'rtl' : 'ltr'
        )
        // this.getUserInfo()
    },
    mounted() {
        if(window.location.href.includes('utm')){
            sessionStorage.setItem('channelUrl',window.location.href)
            }
        if (configs[configs.Edition].socketUrl.length > 0) {
            this.initWebSocket(configs[configs.Edition].socketUrl);
        }
        document.body.style.overflowX = 'hidden'; // 取消 overflow-x 的设置
        document.body.style.overflowY = 'auto'; // 取消 overflow-y 的设置

        // this.sideOperGroupShow = true;
        this.checkPageScroll()
        this._throttleWatch = throttle(this.checkPageScroll, 100)
        window.addEventListener('scroll', this._throttleWatch, true)
        const wowCtrl = new WOW({
            boxClass: 'enter-animate',
            animateClass: 'animate__animated',
            scrollContainer: 'body',
            offset: 100,
        })
        wowCtrl.init()
        mittManage.on('destroy', () => {
            $('body').removeAttr('data-has-scroll')
            $('body').off('scroll', this._throttleWatch)

            wowCtrl && wowCtrl.stop()
        })
        if (configs[configs.Edition].socketUrl.length > 0) {
            this.initWebSocket(configs[configs.Edition].socketUrl)
        }
    },
    methods: {
        // getUserInfo() {
        //     getUserInfo().then((res) => {
        //         console.log(res, '看看个人数据')
        //     })
        // },
        change_language() {
            let paramsName = this.$route.query.language
            const language = getCookie('language') || 'en'
            if (paramsName != language) {
                if (languageArr.indexOf(paramsName) !== -1) {
                    setCookie('language', paramsName)
                    this.$store.dispatch(
                        'setLanguageName',
                        languageName[paramsName]
                    )
                    setCookie('languageName', languageName[paramsName])
                    document.documentElement.setAttribute('lang', paramsName)
                    setTimeout(() => {
                        this.$i18n.locale = paramsName
                    }, 500)
                    this.$router.replace(`/newIndex?language=${paramsName}`)
                } else {
                    this.$router.replace(`/newIndex?language=${language}`)
                }
            }
        },
        checkPageScroll() {
            const pageBody = this.$refs.pageBody
            const scrollTop = document.querySelector('body').scrollTop || 0
            const hasScroll = scrollTop > 0
            $('body').attr('data-has-scroll', hasScroll ? '1' : '0')
            console.log(hasScroll,'hasScroll')
            console.log(scrollTop,'scrollTop')
            if (!pageBody) return
            const bodyPageClientBottom =
                pageBody.$el.getBoundingClientRect().bottom
            this.sideOperGroupShow =
                bodyPageClientBottom - window.innerHeight < 0
            // console.log(`this.sideOperGroupShow`, this.sideOperGroupShow)
        },

        //websocket
        initWebSocket(wsurl) {
            if ('WebSocket' in window) {
                this.websocke = new WebSocket(wsurl)
            } else if ('MozWebSocket' in window) {
                this.websocke = new MozWebSocket(wsurl)
            } else {
                console.log('Your browser does not support websocket.')
                return false
            }
            this.websocke.onopen = this.websocketonopen
            this.websocke.onerror = this.websocketonerror
            this.websocke.onmessage = this.websocketonmessage
            this.websocke.onclose = this.websocketclose
        },
        websocketonopen() {
            console.log('WebSocket连接成功', parseTime(+new Date().getTime()))
            this.heart()
            var channel = {
                op: 'sub',
                args: [
                    'exchange_rate:spot',
                    'spot/config:spot',
                    'spot/home:spot',
                ],
            }
            this.websocketsend(channel)
        },
        websocketonerror(e) {
            //错误
            console.log('WebSocket连接发生错误')
        },
        websocketsend(agentData) {
            //数据发送
            this.websocke.send(JSON.stringify(agentData))
        },
        websocketclose(e) {
            //关闭
            // console.log("connection closed (" + e.code + ")");
            console.log('WebSocket断开连接', parseTime(+new Date().getTime()))
            if (!this.socketStatus) {
                return false
            }
            this.pongTime = null
            this.heartCheck.reset()
            setTimeout(() => {
                this.initWebSocket(configs[configs.Edition].socketUrl)
            }, 5000)
        },
        heart() {
            var _this = this
            this.heartCheck = {
                timeout: 5000,
                timeoutObj: null,
                timeoutObjTwo: null,
                reset: function () {
                    clearTimeout(this.timeoutObj)
                    clearTimeout(this.timeoutObjTwo)
                    this.start()
                },
                start: function () {
                    this.timeoutObj = setTimeout(() => {
                        _this.websocke.send('ping')
                    }, this.timeout)

                    this.timeoutObjTwo = setTimeout(() => {
                        if (
                            _this.pongTime &&
                            new Date().getTime() - _this.pongTime > 8000
                        ) {
                            _this.websocke.close()
                        }
                    }, 10000)
                },
                clear: function () {
                    clearTimeout(this.timeoutObj)
                },
            }
            this.heartCheck.start()
        },
        websocketonmessage(e) {
            //数据接收
            //注意：长连接我们是后台直接1秒推送一条数据，
            //但是点击某个列表时，会发送给后台一个标识，后台根据此标识返回相对应的数据，
            //这个时候数据就只能从一个出口出，所以让后台加了一个键，例如键为1时，是每隔1秒推送的数据，为2时是发送标识后再推送的数据，以作区分
            if (e.data == 'pong') {
                this.pongTime = new Date().getTime()
                this.heartCheck.reset()
                return false
            }
            var res = JSON.parse(this.decode(e.data))
            // console.log(res)
            var _this = this
            if (res.table == 'spot/config' && res.data) {
                _this.listLoading = false
                res.data.forEach((v) => {
                    v.priceTick = toNonExponential(v.priceTick)
                    v.sizeTick = toNonExponential(v.sizeTick)
                })
                for (let i in res.data) {
                    _this.marketConfig[res.data[i]['symbol']] = res.data[i]
                }
                localStorage.setItem(
                    'marketConfig',
                    JSON.stringify(_this.marketConfig)
                )
                this.$store.dispatch(
                    'setCurrentMarketConfig',
                    _this.marketConfig['btc_usdt']
                )
                localStorage.setItem(
                    'currentMarketConfig',
                    JSON.stringify(_this.marketConfig['btc_usdt'])
                )
                
                const tempData = Object.assign([], res.data);
                tempData.forEach(v => {
                    v.priceTick = toNonExponential(v.priceTick)
                })
                var marketConfig = {}
                for (let i in tempData) {
                    marketConfig[tempData[i]['symbol']] = tempData[i]
                }
                this.marketsCoinConfig = marketConfig


            } else if (res.table == 'swap/config' && res.data) {
                var contractConfig = {}
                res.data.forEach((v) => {
                    v.priceTick = toNonExponential(v.priceTick)
                })
                for (let i in res.data) {
                    contractConfig[res.data[i]['symbol']] = res.data[i]
                }
                localStorage.setItem(
                    'contractConfig',
                    JSON.stringify(contractConfig)
                )
                this.$store.dispatch(
                    'setCurrentContractConfig',
                    contractConfig['btc_usdt']
                )
                localStorage.setItem(
                    'currentContractConfig',
                    JSON.stringify(contractConfig['btc_usdt'])
                )
            } else if (res.table == 'exchange_rate' && res.data) {
                // console.log('res.data-exchange_rate', res.data)
                // console.log(res.data, 'exchange_rate')
                for (let i in res.data) {
                    _this.rateConfig[res.data[i]['currency']] = res.data[i]
                }
                localStorage.setItem(
                    'rateConfig',
                    JSON.stringify(_this.rateConfig)
                )
            } else if (res.table == 'spot/home' && res.data) {
                // console.log('res.data spot/home', res.data)
                res.data.forEach((v) => {
                    v.recentQuotation = toNonExponential(v.recentQuotation)
                    v.state = _this.marketConfig[v.symbol]
                        ? _this.marketConfig[v.symbol].state
                        : '3'
                })
                
                if(!_this.marketList.length){
                    _this.marketList = res.data
                }else{
                    res.data.forEach(el => {
                        let index = _this.marketList.findIndex((_el) => _el.symbol == el.symbol)
                        if(index >= 0){
                            this.$set(_this.marketList, index, el)
                            // _this.marketList.slice(index, el)
                        }else{
                            _this.marketList.push(el)
                        }
                    })
                }
                
                // console.log(_this.marketList, '看看_this.marketList====')
            }
        },
        decode(encodedData) {
            try {
                const decodedData = atob(encodedData);
                const uint8Array = new Uint8Array(decodedData.split('').map(function (x) {
                return x.charCodeAt(0);
                }));
                const inflatedData = pako.inflate(uint8Array);
                const result = new TextDecoder().decode(inflatedData);
                return result;
            } catch (error) {
                console.error('Error decompressing GZIP data:', error);
                return null;
            }
            // var decodedData = window.atob(encodedData)
            // var charData = decodedData.split('').map(function (x) {
            //     return x.charCodeAt(0)
            // })
            // var binData = new Uint8Array(charData)
            // var data = pako.inflate(binData)
            // var myArr = new Uint16Array(data)
            // var num = 1000,
            //     strings = ''
            // var uintArray = new Uint16Array(data)
            // var converted = []
            // uintArray.forEach(function (byte) {
            //     converted.push(String.fromCharCode(byte))
            // })
            // return converted.join('')
        },
    },
    destroyed() {
        this.socketStatus = false
        clearInterval(this.heartCheck.timeoutObj)
        clearInterval(this.heartCheck.timeoutObjTwo)
        this.pongTime = null
        this.websocke.close()
    },
    beforeDestroy() {
        mittManage.emit('destroy')
        mittManage.all.clear()
        window.removeEventListener('scroll', this.checkPageScroll, true) // 清除滚动事件
        this.checkPageScroll = null
    },
}
</script>
<style lang="scss">
// @import '../assets/tailwendcss.css';
//tailwendcss
// .flex {
//  display: flex;
// }
// .justify-center{
//     justify-content: center;
// }
// .items-center{
//     align-items: center;
// }
// .justify-between{
//     justify-content: space-between;
// }
// .justify-start{
//     justify-content: flex-start;
// }
// .justify-end{
//     justify-content: flex-end;
// }
// .grid {
//     display: grid;
// }
// .grid-flow-col-dense {
//     grid-auto-flow: column dense;
// }
// // enter-animate animate__fadeInUp
// .enter-animate{
//     visibility: visible;
//     animation-name: fadeInUp;
// }

//正常
[dir='ltr'] {
}
//波斯
[dir='rtl'] {
}
</style>
<style lang="scss" module>
// @import "../../assets/uemo-scss/scss/abstracts/_mixins.scss";
@import '../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../assets/uemo-scss/scss/abstracts/_functions.scss';

//new
// @import "../assets/uemo-icon-font/fonts/ueicon.css";
// @import "../assets/newCss/var.scss";
// @import "../assets/newCss/base.scss";
@import '../assets/newCss/reset.scss';

// body{
//     background-color: #17171a;
// }
.g-body {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 100%;
    line-height: 1.4 !important;
}
.side-oper-group {
    position: fixed;
    z-index: calc(var(--g--layer--z-index--lv1) - 10);
    right: 20px;
    bottom: calc(var(--g--safe-area-bottom) + 302px);

    visibility: hidden;

    transition: 0.26s ease;

    opacity: 0;

    gap: 20px;
    .oper-item {
        @include circle(80px);
        font-size: 40px;

        transition: 0.26s ease;

        color: color(var(--g--color-font--default), 0.5);
        background-color: #454545;
    }
    &[data-state-show] {
        right: 30px;

        visibility: visible;

        opacity: 1;
    }
}
.join-us {
    position: sticky;
    z-index: calc(var(--g--layer--z-index--lv1) - 10);
    right: 0;
    bottom: calc(var(--g--safe-area-bottom) + 40px);
    left: 0;

    width: 690px;
    margin: 0 auto;
    padding: 30px;

    // border: 1px solid rgb(223 233 251 / 0.2);
    border: 1px solid rgba(223, 233, 251, 0.2);

    border-radius: 12px;
    // background: rgb(45 45 45 / 0.3);
    background: rgba(45, 45, 45, 0.3);

    backdrop-filter: blur(10px);
    .join-us-thumb {
        height: 64px;
    }
    .btn--download-app {
        font-size: 24px;
        font-weight: 500;

        padding: 16px 32px;

        text-align: center;

        color: #fff;
        border-radius: 100px;
        // background-color: color(var(--g--color-theme--main));
        background-color: #FFC72B;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/newIndex.vue